export default __webpack_public_path__ + "static/media/error-init.c882bf90.jpg";